import { apiUms } from './index';

export const updatePricingFields = (body) => {
	return apiUms.put('/ums/ts/pricing-preferences', body);
};

export const getPricingDetails = (companyId) => {
	return apiUms.get('/ums/ts/pricing-preferences', { params: { companyId } });
};
